// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"

// Constants
import { STATES } from "@/app/constants/state-constants.js"
import { STATUS_CODES } from "@/app/constants/status-constants"

//Service
import paymentService from "@/app/services/main/payment/payment-service.js"

export default {
	name: "PuppyPurchasePayNowPage",
	mixins: [dateMixins, toastMessageMixins, userMixins],
	props: {
		puppyPurchaseDetails: {
			required: true,
			default: null,
		},
		successTitle: {
			type: String,
			default: "Congratulations, your purchase has been approved!",
		},
		subTitle: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			isAPILoading: false,
			termsAndConditions: false,
			isAgreed: true,
		}
	},
	computed: {
		isNativeApp() {
			return this.$store.getters.getIsNativeApp
		},
	},
	watch: {
		termsAndConditions() {
			if (this.termsAndConditions === false) {
				this.isAgreed = false
				return
			}
			this.isAgreed = true
		},
	},
	mounted() {
		const { id, totalAmount, puppyDetails } = this.puppyPurchaseDetails

		window.LatitudeCheckout = {
			merchantId: process.env.VUE_APP_MERCHANT_ID,
			page: "product",
			container: "latitude-banner-container",
			containerClass: "",
			currency: "AUD",
			minAmount: "",
			layout: "inversed",
			paymentOption: "equal",
			promotionMonths: "24",
			product: {
				id: id,
				name: `${puppyDetails.breedName} and product shop credit`,
				category: "Dog Purchase",
				price: totalAmount,
				sku: id,
			},
		}

		this.createLatitudeScript()
	},
	methods: {
		createLatitudeScript() {
			const script = document.createElement("script")
			script.src = `${process.env.VUE_APP_MERCHANT_URL}${process.env.VUE_APP_MERCHANT_ID}`
			document.body.appendChild(script)
		},
		mobileNumberFormat(mobileNumber) {
			if (mobileNumber) {
				let data = mobileNumber.split("")
				data.splice(4, 0, "-")
				return data.join("")
			} else {
				return ""
			}
		},
		stateName(state) {
			return state ? STATES[state] : ""
		},
		totalPriceValue(details) {
			return parseFloat(details.price) + parseFloat(details.storeCredit)
		},
		contactUsEmail() {
			window.location.href = "mailto:services@lovemydogclub.com.au"
		},
		proceedToLatitude() {
			const { referenceId, token } = this.$route.query

			if (!this.termsAndConditions) {
				this.showCustomErrorToast(null, "You must agree to the Privacy and Consumer Policy to proceed.")
				this.isAgreed = false
				return
			}

			this.isAPILoading = true

			const queryParams = {
				f_puppyPurchaseId : this.puppyPurchaseDetails.id
			}
			paymentService.getLatitudeInterestFreeUrlForProductPurchasePublic(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						if (res.data) {
							const { redirectUrl } = res.data
							this.$swal({
								title: "Redirecting to ...",
								html: `<img style='width: 300px' src=${require("@/assets/images/_shared/latitude-interest-free-logo.svg")}>`,
								allowOutsideClick: false,
								timer: 2000,
								showCancelButton: false,
								showConfirmButton: false,
							}).then(() => {
								window.location = redirectUrl
							})
						} else {
							this.showGenericErrorToast()
						}
					} else {
						this.showAPIErrorToast("Unable to process your purchase.", res)
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
				})
				.finally(() => {
					this.isAPILoading = false
				})
		},
	},
	// third party libraries
}
